var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-navbar',{attrs:{"type":"is-cooldark"}},[_c('template',{slot:"start"},[_c('b-navbar-item',{attrs:{"href":"home"}},[_c('img',{attrs:{"src":require("./assets/knight_blue.png"),"alt":"blue knight"}}),_vm._v("Home")]),_vm._v(" "),_c('b-navbar-item',{attrs:{"href":"art"}},[_c('img',{attrs:{"src":require("./assets/art.png"),"alt":"art"}}),_vm._v("Art")])],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f29ed860","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Navbar.vue
// module id = 91
// module chunks = 0